import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import GameMenu from "@/pages/GameMenu";
import Landing from "@/pages/Landing";
import Host from "@/pages/Host";
import Play from "@/pages/Play";
import Admin from "@/pages/Admin";
import UnoLanding from "@/pages/UnoLanding";
import UnoHost from "@/pages/UnoHost";
import UnoPlay from "@/pages/UnoPlay";

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GameMenu />} />
          <Route path="/biblico" element={<Landing />} />
          <Route path="/host" element={<Host />} />
          <Route path="/play" element={<Play />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/serie" element={<UnoLanding />} />
          <Route path="/serie/host" element={<UnoHost />} />
          <Route path="/serie/play" element={<UnoPlay />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
